import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useApplicationCodesList() {

    //User toast
    const toast = useToast()

    const refApplicationCodeListTable = ref(null)

    const tableColumns = [
        {key: 'code_name', label:'代碼', sortable: true},
        {key: 'is_active', label:'狀態', sortable: true},
        {key: 'action', label: '操作'}
    ]

    const perPage = ref(10)
    const totalApplicationCodes = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refApplicationCodeListTable.value ? refApplicationCodeListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalApplicationCodes.value,
        }
    })

    const refetchData = () => {
        refApplicationCodeListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchApplicationCodes = (ctx, callback) => {
        store.dispatch('setting-applicationcode/fetchApplicationCodes',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {applicationcodes, total} = response.data
            callback(applicationcodes)
            totalApplicationCodes.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching application codes list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchApplicationCodes,
        tableColumns,
        perPage,
        currentPage,
        totalApplicationCodes,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refApplicationCodeListTable,
        ability,
        refetchData
    }

}